
export enum ToastType {
  success = 'success',
  error = 'error',
  info = 'info',
  warning = 'warning',
  default = 'default'
}